import React from 'react';

import { Label } from '@opengov/component-library';

import styles from './AppSwitcherPopoverTrigger.module.scss';

export const AppSwitcherPopoverTrigger = () => {
  return (
    <>
      <div className={styles.grid}>
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
        <div className={styles.gridItem} />
      </div>
      <Label className={styles.ogLabel}>OpenGov Cloud</Label>
    </>
  );
};
